module.exports = __webpack_public_path__ + "static/isometric-c3b4597f1ebb17bf80494121f4fd3738.svg";